import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {MessageService} from 'primeng/api';
import {ContactTypeService} from '../../../../_services/contact-type-service';
import {GroupedRole, Role} from '../../../../_models/contact-type.model';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-contact-type-add',
    templateUrl: './add-contact-type.component.html',
    styleUrls: ['../contact-type.component.scss', './add-contact-type.component.scss']
})
export class ContactTypeAddComponent implements OnInit, OnDestroy {

    @Output() completed = new EventEmitter<string>();
    loading = false;
    contactTypeForm: FormGroup | undefined;
    roleGroups: GroupedRole[] = [];
    roles: Role[] = [];
    roleCheckboxes: boolean[] = [];
    showStep1 = true;
    showStep2 = false;
    private _finalRoles: number[] = [];
    private _doSubmit = true;
    private _currentProcess: Subscription = new Subscription();
    private _rolesSub: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private readonly messageService: MessageService,
        private contactTypeService: ContactTypeService
    ) {
        this._rolesSub = this.contactTypeService.getRoles().subscribe(r => {
            this.roleGroups = r.data;
            this.roleGroups.map(roleGroup => {
                roleGroup.roles.map(r => {
                    this.roleCheckboxes[r.id] = false;
                });
            });
            // Make general user true
            this.roleCheckboxes[6] = true;
            this.initForm();
            return r;
        });
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
        this._rolesSub.unsubscribe();
    }

    onRoleChange(roleId: number): void {
        this.roleCheckboxes[roleId] = !this.roleCheckboxes[roleId];
        // this.makeFinalRoles();
    }

    private initForm(): void {
        this.contactTypeForm = new FormGroup({
            name: new FormControl('', Validators.required),
            description: new FormControl('')
        });
    }

    onContactTypeAddSubmit(): void {
        this.loading = true;
        if (typeof this.contactTypeForm !== 'undefined') {
            if (this._doSubmit) {
                this.upsertContactType();
            }
        }
    }

    go(step: number): void {
        if (this.contactTypeForm) {
            if (step === 1) {
                this.showStep2 = false;
                this.showStep1 = true;
            } else if (step === 2 && (this.contactTypeForm.value.name === null || this.contactTypeForm.value.name.length < 4)) {
                const message = 'Please enter a proper contact type name before continuing.';
                this.messageService.add({key: 'contactTypeNameMissing', severity: 'error', summary: message});
            } else if (step === 2 && this.contactTypeForm.value.name.length > 3) {
                this.messageService.clear('contactTypeNameMissing');
                this.showStep1 = false;
                this.showStep2 = true;
            }
        }
    }

    private upsertContactType(): void {
        if (typeof this.contactTypeForm !== 'undefined') {
            this.makeFinalRoles();
            this.logger.debug('[ContactTypeAddComponent] Adding new contact type');
            this._currentProcess = this.contactTypeService.upsertContactType(
                this.contactTypeForm.value.name,
                this.contactTypeForm.value.description,
                1,
                this._finalRoles
            ).subscribe(newContactType => {
                this.logger.debug('[ContactTypeAddComponent] Contact type added successfully: ', newContactType.id);
                this.initForm();
                this.loading = false;
                this.completed.emit('added');
            }, (error: any) => {
                this.logger.debug('[ContactTypeAddComponent] Contact type failed to add');
                this.logger.error(error);
                this.loading = false;
            });
        }
    }

    onCancel(): void {
        this.logger.debug('[ContactTypeAddComponent] Add Contact type modal Cancelled');
        this.completed.emit('cancelled');
    }

    makeFinalRoles(): void {
        this._finalRoles = [];
        this.roleCheckboxes.map((r, i) => {
            if(r) {
                this._finalRoles.push(i);
            }
        });
    }
}
